<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M37.8449 77.431L27.9918 34.1611C27.4501 31.7737 28.9444 29.3923 31.3317 28.8446L77.0009 18.4439C79.3883 17.9021 81.7697 19.3964 82.3174 21.7838L96.8856 85.5456C97.4333 87.9389 95.9271 90.3263 93.5278 90.8561L68.4934 96.4048"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.5714 79.5981C71.459 77.3179 74.3167 73.8709 76.1444 69.2569C77.9722 64.643 78.3353 59.904 77.228 55.0281L74.6263 43.6093L58.8912 41.472L45.6328 50.2117L48.2345 61.6305C49.3418 66.5064 51.7232 70.6203 55.3668 73.984C59.0163 77.3477 63.0825 79.2171 67.5714 79.5922V79.5981Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.2715 57.838L63.8386 63.7617L80.3 43.9902"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M69.6542 21.0573L78.3642 19.0272C80.4479 18.545 82.5316 19.8369 83.0138 21.9206L96.8616 81.6043C98.0702 86.6231 94.9208 91.6598 89.8723 92.7671L88.9256 92.9517L64.6295 98.1967L48.4062 101.668C41.2025 103.21 34.4989 97.1072 35.6538 89.832C36.0289 87.4744 37.7733 85.0216 40.1844 83.9559C44.1911 82.1878 48.3348 84.0869 50.6328 86.6648C55.8421 92.523 56.7768 102.989 51.9664 110.372C48.4836 115.718 43.1552 117.825 40.9048 118.558"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M70.089 18.0329L61.6826 19.95C61.1349 20.075 60.5574 19.9797 60.0811 19.688L58.6166 18.795C58.9857 17.7472 59.0393 16.5743 58.6999 15.4134C57.9141 12.7581 55.2052 11.0793 52.4785 11.5615C49.3291 12.1211 47.3466 15.1991 48.0849 18.2651C48.3409 19.3308 48.8945 20.2536 49.6387 20.9561L48.8826 22.2004C48.579 22.6945 48.0908 23.0458 47.5252 23.1768L38.2497 25.2902C36.5053 25.6891 35.4158 27.4216 35.8147 29.166C36.2136 30.9103 37.9461 31.9998 39.6904 31.6009L71.5357 24.3496C73.28 23.9507 74.3695 22.2182 73.9706 20.4739C73.5717 18.7295 71.8393 17.64 70.0949 18.0389L70.089 18.0329ZM53.062 15.2705C53.7824 15.0979 54.5087 15.5384 54.6813 16.2648C54.854 16.9851 54.4134 17.7114 53.6871 17.8841C52.9667 18.0568 52.2404 17.6162 52.0677 16.8899C51.8951 16.1695 52.3357 15.4432 53.062 15.2705Z"
            class="primary-fill" />
    </svg>
</template>
